import { Button, Image, Input, Modal } from 'antd'
import GoogleAnalyticsUtils from '../utils/GoogleAnalyticsUtils'
import GoogleAnalyticsConsts from '../../const/GoogleAnalyticsConsts'
import { useAppDispatch } from '../../store/hooks'
import WordListUtils from '../utils/WordListUtils'
import { FC, useEffect, useState } from 'react'
import { createInCommunity, createWordList } from '../../store/wordLists/extraReducers'
import { CommunityDto, ID } from '../../shared/types/api'
import * as API_TREES from '../../shared/http/trees'
import Constants from '../../const/Constants'

interface TreeItem {
    id: number
    name: string
    isPremium: boolean
    isEnable: boolean
}

interface AddCardListDialogProps {
    isOpen: boolean,
    community?: CommunityDto
    close: () => void
}

const AddCardListDialog: FC<AddCardListDialogProps> = ({ isOpen, close, community }) => {
    const dispatch = useAppDispatch()
    const [name, setName] = useState<string>('')
    const [loading, setLoading] = useState<boolean>(false)
    const [valid, setValid] = useState<boolean>(true)
    const [trees, setTrees] = useState<TreeItem[]>([])
    const [selectedTreeId, setSelectedTreeId] = useState<number | undefined>(undefined)

    useEffect(() => {
        if (isOpen) {
            API_TREES.getEnabled().then((resp: TreeItem[]) => {
                if (resp && resp.length > 0) {
                    setTrees(resp)
                }
            })
        }
    }, [isOpen])

    const clearAndClose = () => {
        setName('')
        setSelectedTreeId(undefined)
        close()
    }

    const addCardList = () => {
        if (name.length === 0) {
            setValid(false)
        } else {
            GoogleAnalyticsUtils.createEvent(GoogleAnalyticsConsts.DICTIONARY_ADD_CARD_LIST)
            setLoading(true)
            if (!!community) {
                const wordList = WordListUtils.createNewCommunityCardList(community.id, name, selectedTreeId)
                saveWordListInCommunity(community.id, wordList, wordList.id)
            } else {
                const wordList = WordListUtils.createUserCardList(name, selectedTreeId)
                saveWordList(wordList, wordList.id)
            }
        }
    }

    /**
     * Сохранить список карточек
     * @param data
     * @param id
     */
    const saveWordList = (data: any, id: ID) => {
        dispatch(createWordList({ savedWordList: data, id })).then((r) => {
            setLoading(false)
        }).finally(() => {
            clearAndClose()
        })
    }

    /**
     * Сохранить список слов в сообществе
     * @param communityId
     * @param data
     * @param id
     */
    const saveWordListInCommunity = (communityId: number, data: any, id: ID) => {
        dispatch(createInCommunity({ communityId, data, id })).then((r) => {
            setLoading(false)
        }).finally(() => {
            clearAndClose()
        })
    }

    const onChangeName = (e: any) => {
        const value = e.target.value
        if (value.length !== 0 && !valid) {
            setValid(true)
        }
        setName(value)
    }

    return (
        <Modal title='Создание списка карточек'
               onCancel={clearAndClose}
               footer={[
                   <Button key='submit' onClick={clearAndClose}>
                       Отмена
                   </Button>,
                   <Button
                       disabled={!name}
                       onClick={addCardList}
                       loading={loading}
                       type='primary'
                   >
                       Сохранить
                   </Button>
               ]}
               open={isOpen}>
            <p>Придумайте название для списка карточек, например "Одежда"</p>
            <Input status={!valid ? 'error' : ''} value={name} onChange={onChangeName} size='large'
                   placeholder='Название списка карточек'
                   maxLength={50}
            />
            {trees.length > 0 && (
                <>
                    <p style={{ marginTop: 16 }}>Выберите дерево</p>
                    <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                        {trees.map((tree) => (
                            <div
                                key={tree.id}
                                onClick={() => setSelectedTreeId(tree.id)}
                                style={{
                                    cursor: 'pointer',
                                    border: selectedTreeId === tree.id ? '3px solid #1890ff' : '3px solid transparent',
                                    borderRadius: 8,
                                    padding: 4,
                                    textAlign: 'center'
                                }}
                            >
                                <Image
                                    src={`${Constants.queryConst}/v1/trees/image/${tree.id}/JUST_PLANTED`}
                                    preview={false}
                                    width={60}
                                    height={60}
                                    style={{ borderRadius: 8 }}
                                />
                                <div style={{ fontSize: 12 }}>{tree.name}</div>
                            </div>
                        ))}
                    </div>
                </>
            )}
        </Modal>
    )
}

export default AddCardListDialog
